export const campaignsSearchByRetailerAccountsSelector = (state) =>
  (state.retailerAccountsCampaignsSearch &&
    state.retailerAccountsCampaignsSearch.byRetailerAccountId) ||
  {}
